import { DeleteOutline, FileDownloadOutlined, FilePresentOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { openUrlWithNewWindow } from 'libs/uikit/src/utils/url';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var JoveFileItemView = function JoveFileItemView(props) {
  var className = props.className,
      info = props.info,
      _props$openFileType = props.openFileType,
      openFileType = _props$openFileType === void 0 ? 'custom' : _props$openFileType,
      _props$size = props.size,
      size = _props$size === void 0 ? 'normal' : _props$size,
      _props$documentIdKey = props.documentIdKey,
      documentIdKey = _props$documentIdKey === void 0 ? 'document_id' : _props$documentIdKey,
      _props$documentNameKe = props.documentNameKey,
      documentNameKey = _props$documentNameKe === void 0 ? 'name' : _props$documentNameKe,
      downloadItem = props.downloadItem,
      deleteItem = props.deleteItem,
      hideDownloadButton = props.hideDownloadButton,
      hideDeleteButton = props.hideDeleteButton,
      _props$openUrlKey = props.openUrlKey,
      openUrlKey = _props$openUrlKey === void 0 ? 'url' : _props$openUrlKey;
  /**
   * methods
   */

  var downloadFileAction = function downloadFileAction() {
    if (!!downloadItem) {
      downloadItem(info);
    } else {
      if (openFileType === 'custom') {
        openUrlWithNewWindow(info[openUrlKey]);
      }
    }
  };

  var deleteItemAction = function deleteItemAction() {
    deleteItem === null || deleteItem === void 0 ? void 0 : deleteItem(info);
  };

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('boder-[#E2E2E2] flex cursor-pointer flex-row items-center space-x-1 rounded-lg border px-3 py-2', className),
    children: [/*#__PURE__*/_jsx(FilePresentOutlined, {
      className: "h-6 w-6 text-[#0E35D1]"
    }), /*#__PURE__*/_jsx(Box, {
      className: "w-0 flex-1",
      children: /*#__PURE__*/_jsx(Typography, {
        variant: "subtitle1",
        className: "truncate font-bold text-[#202020]",
        children: info === null || info === void 0 ? void 0 : info[documentNameKey]
      })
    }), !hideDownloadButton && /*#__PURE__*/_jsx(FileDownloadOutlined, {
      onClick: downloadFileAction
    }), !hideDeleteButton && /*#__PURE__*/_jsx(DeleteOutline, {
      onClick: deleteItemAction
    })]
  });
};

export default JoveFileItemView;